/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import './pictograms.css'
import FilterSVG from 'component/svgComponents/filter'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import FilterForm from 'component/pictograms/PictogramFilterForm'
import PictogramModalNew from 'component/pictograms/PictogramModalNew'
import PictogramModalErrorNew from 'component/pictograms/PictogramErrorModalNew'
import PictogramEditModal from 'component/pictograms/PictogramEditModalNew'
import Title from 'component/pictograms/PictogramTitleNew'
import SideFilterForm from 'component/pictograms/PictogramSideFilterFormNew'
import Table from 'component/pictograms/PictogramTableNew'
import Row from 'component/utils/Row'
import * as attributeActions from 'action/attribute'
import NewPagination from 'component/pagination/newPagination'
import SizeSelect, {components} from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import PictogramAddOrRemoveModal from '../../components/pictograms/PictogramAddOrRemoveModal'
import data from './mock'
import PictogramViewModal from 'component/pictograms/PictogramViewModal'
import PictogramRemoveModal from 'component/pictograms/PictogramRemoveModal'
import { isEmpty } from 'utils/validations'

const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 0,
  size: 10, 
}

const DEFAULT_INITIAL_VALUES = {
  order: 'name',
  orderDirection: "ASC",
 
  page: 0,
  size: 10,
  statusFormat: "ALL",
  status: 2
  
}

const EXTRA_SMALL_SCREEN = 768

const PictogramContainer = ({
  auth: {
    user: { dsToken },
  },
  translate,
  saveAttribute,
  fetchAttributes,
  deleteAttributes,
  updateAttribute,
  get,
  update,
  save,
  resetSave,
  resetAll,
  auth
}) => {
  const [openEditModal, setOpenEditModal] = useState({show:false, selected: null})
  const [emptyFilter, setEmptyFilter] = useState(true)
  const [openDeleteModal, setOpenDeleteModal] = useState({show: false, selected: null})
  const [openViewModel,setOpenViewModel] = useState({show: false, selected: null})
  const [successModalText, setSuccessModalText] = useState("O cadastro foi salvo com sucesso!")
  const [successModalEditText, setSuccessModalEditText] = useState("O cadastro foi alterado com sucesso!")
  const [successModalDeleteText, setSuccessModalDeleteText] = useState()
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [openSuccessEditModal, setOpenSuccessEditModal] = useState(false)
  const [openEditSuccessDeleteModal, setopenEditSuccessDeleteModal] = useState(false)
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [optionSize, setOptionSize] = useState(10)
  const [totalPages, setTotalPages] = useState(1)
  const [cdMissionList, setCdMissionList] = useState([])
  const [openAddModal,setOpenAddModal] = useState(false)
  const [attributeData, setAttributeData] = useState(data)
  const headerRef = useRef(null)
  const filterRef = useRef(null)
  const [attributeAlreadyExists, setAttributeAlreadyExists] = useState(false)
  const tableRef = useRef(null)

  const [filters, setFilters] = useState()
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [sideFilterElement, setSideFilterElement] = useState(null)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [sideFilterWidth, setSideFilterWidth] = useState(0)
  const [depositListWithoutPermission, setDepositListWithoutPermission] = useState([])
  const [topMargin, setTopMargin] = useState(0)
  const [errorDetails,setErrorDetails] = useState("Tempo Expirado")
  const [missionListSelected, setMissionListSelected] = useState([])
  const [actionMode, setActionMode] = useState(false)

  const [order,setOrder] = useState({order: 'name', orderDirection: 'ASC'})
  // Did mount
  useEffect(() => {
    // fetch attributes on mount
    const param = {
      ...DEFAULT_INITIAL_VALUES,
      ...DEFAULT_PAGINATION
    }
    setFilters(DEFAULT_INITIAL_VALUES)

    return () => {
      resetAll()
    }
  }, [])

  // When filters change
  useEffect(() => {

    if(!filters) return
    const param = {
      ...DEFAULT_PAGINATION,
      ...filters,
      ...order,
      page: 0,
      size: optionSize
    }
    
    // fetch with filters
    handleAttributes(param)
    
  }, [filters])

  // When pagination changes
  useEffect(() => {
    if(!filters) return
    const param = {
      ...filters,
      ...pagination,
      ...order,
      page: pagination.page
    }
    
    handleAttributes(param)
  }, [pagination])

  // Will unmount
  useEffect(() => () => window.removeEventListener('resize', handleResize))

  const handleResize = () => {
    const header = headerRef.current

    if (header && window.innerWidth > EXTRA_SMALL_SCREEN) {
      const headerClientHeight = header.clientHeight

      const filter = filterRef.current

      const topHeight = headerClientHeight + filter.clientHeight

      let newSideFilterWidth = sideFilterWidth

      filter.style.top = `${headerClientHeight}px`

      if (sideFilterVisible && sideFilterElement)
        newSideFilterWidth = sideFilterElement.clientWidth

      if (topMargin !== topHeight || sideFilterWidth !== newSideFilterWidth) {
        setSideFilterWidth(newSideFilterWidth)

        setTopMargin(topHeight)
      }
    }
  }

  const handleAttributes = (param) => {

    // fetch with params
    fetchAttributes(dsToken,param)
  }

  useEffect(() => {
   
  }, [get])

  useEffect(() => {
    
    if(update.error && update.error.cdStatus === 400) {
      setAttributeAlreadyExists(true)
      return
    }

    if(update.error && update.error.cdStatus === 500) {
      if(update.error.data) {
        setErrorDetails(update.error.data)
      }
      setOpenErrorModal(true)
      return
    }

    if(!update.error && !isEmpty(update.record) ) {
      setOpenEditModal(false)
      setOpenSuccessEditModal(true)
      
    }

  }, [update])


  useEffect(() => {
    
    if(save.error && save.error.cdStatus === 400) {
        setAttributeAlreadyExists(true)
        return
    } 

    if(save.error && save.error.cdStatus === 500) {
      if(save.error.data) {
        setErrorDetails(save.error.data)
      }
      setOpenErrorModal(true)
      return
    }

    if(!save.error && !isEmpty(save.record) ) {
      setOpenAddModal(false)
      setOpenSuccessModal(true)
      resetSave()
      
    }
  }, [save])

  const closeFilter = () => setSideFilterVisible(false)

  const resetFilters = () => setValues(DEFAULT_INITIAL_VALUES)

  const setValues = (values, isSearch = false) => {

    if(isSearch && values) {
      setEmptyFilter(false)
      setFilters({...filters, name: values, page: 0, o: Math.random()})
      return
    }

    if(isSearch && !values) {
      delete filters.name
      
      setFilters({...filters, page: 0, o: Math.random()})
      setEmptyFilter(true)
      return
    }

    switch(values.status) {
        case 0:
          values.statusFormat = "COMPLETE"
          break;
        case 1:
          values.statusFormat = "INCOMPLETE"
          break;
        default:
          values.statusFormat = "ALL"
          break;
    }
      setFilters({ ...filters, ...values, page: 0, o: Math.random() })
    
  }

  const renderRemoveModal = () => {
    
    if(!openDeleteModal.show) return;

    return <PictogramRemoveModal action={handleDelete} closeModal={() => setOpenDeleteModal({show: false, selected: null})} multiples={openDeleteModal.selected} attribute={openDeleteModal.selected} translate={translate} />

  }

  const callBackDelete = () => {
    
    setOpenDeleteModal({show: false, selected: null})
    setopenEditSuccessDeleteModal(true)
    setMissionListSelected([])
    setCdMissionList([])
   
  }
  const handleDelete = () => {

    if(openDeleteModal.selected.length <= 1 || !Array.isArray(openDeleteModal.selected)) {
      setSuccessModalDeleteText("O atributo foi excluído com sucesso!")
    }
    else {
      setSuccessModalDeleteText("Os atributos foram excluídos com sucesso!")
    }
    
    let arrayToSend;

    if(!Array.isArray(openDeleteModal.selected)) {
      arrayToSend = [openDeleteModal.selected]
    }
    else {
      arrayToSend = openDeleteModal.selected
    }
    deleteAttributes(dsToken, arrayToSend, callBackDelete)
  }

  const renderNewPagination = () => {
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

    const countItems = () => {

      if(get.record.pages.page + 1 === 1) return 1

      return (((get.record.pages.page + 1) - 1) * optionSize) + 1
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if(!(get.record.resultList ?? []).length) return

    return (
    <Row className="new-relatory-row stock-transfer-pagination" >
                      <Col className="align-center margin-bottom ">

                      <NewPagination
                      navClass='pagination new-relatory'
                      count={get.record.pages.totalCount}
                      current={get.record.pages.page + 1}
                      getPage={(page) => setPagination({ ...pagination, size: optionSize,  page: page - 1 })}
                      pages={get.record.pages.pageCount}
                    />

                    <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
                            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
                            <Col xs={4}>
                              <SizeSelect
                              components={{DropdownIndicator}}

                                isSearchable={false}
                                styles={colourStyles}
                                classNamePrefix='react-select'
                                onChange={(option) => {
                                  setOptionSize(option.value)
                                  setPagination({...pagination, page: 0, size: option.value})
                                }}
                                options={PAGINATION_OPTIONS}
                                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                                menuPlacement='top'
                              />
                            </Col>
                      </div>


                      <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
                            <Col >{`
                            ${translate('pagination.size.show')}
                            ${countItems()} - ${(get.record.pages.page + 1) * optionSize > get.record.pages.totalCount ? get.record.pages.totalCount : (get.record.pages.page + 1) * optionSize }
                            ${translate("pagination.size.of")}
                            ${get.record.pages.totalCount}
                            ${translate("pagination.size.items")}`}</Col>

                      </div>

                    </Col>


                  </Row>
    )
  }

  const renderViewModel = () => {
    if(!openViewModel.show) return

    return (
      <PictogramViewModal
        closeModal={() => setOpenViewModel({show: false, selected: null})}
        attribute={openViewModel.selected}
        translate={translate}
      />
    )
  }

  const renderEditModal = () => {
    if (!openEditModal.show) return

    return (
      <PictogramEditModal
        attributeAlreadyExists={attributeAlreadyExists}
        handleAttributeAlreadyExists={(value ) => setAttributeAlreadyExists(value)}
        closeModal={() => setOpenEditModal({show: false, selected: null})}
        attribute={openEditModal.selected}
        token={auth.user.dsToken}
        translate={translate}
        action={handleUpdate}
      />
    )
  }

  useEffect(() => {
    if(cdMissionList.length === 0) {
      setMissionListSelected([])
      return
    }
    const selecteds = [...data].filter(mission => cdMissionList.includes(mission.id))
    
    const cloneSelecteds = [...missionListSelected]
    selecteds.forEach((element) => {
      const findMission = missionListSelected.filter(mission => element.id === mission.id).length > 0
      if(!findMission) cloneSelecteds.push(element)
    })
    setMissionListSelected(cloneSelecteds)

  },[cdMissionList])

  const removeSelected = (cdMission) => {
    const hasSelected = data.filter(mission => mission.id === cdMission).length > 0
    if(hasSelected) {
      const newSelecteds = [...missionListSelected].filter(mission => mission.id !== cdMission)

      setMissionListSelected(newSelecteds)
    }
  }


  const renderAddModal = () => {
    
    if(!openAddModal) return
    return (
      <PictogramAddOrRemoveModal
        closeModal={() => setOpenAddModal(false)}
        submit={beforeSave}
        user={auth.user}
        token={auth.user.dsToken}
        attributeAlreadyExists={attributeAlreadyExists}
        handleAttributeAlreadyExists={(value ) => setAttributeAlreadyExists(value)}
        translate={translate}
      />
    )
  }

  const renderErrorModal = () => {
    if(!openErrorModal) return
    return (
      <PictogramModalErrorNew
        onConfirm={() => setOpenErrorModal(false)}
        text={"Houve um erro ao cadastrar o atributo/característica"}
        title={'Ops!'}
        details={errorDetails}
        okButton={'Tentar novamente'}
      />
    )
  }


  const renderSuccessEditModal = () => {

    if(!openSuccessEditModal) return
    return (
      <PictogramModalNew
        onConfirm={() => { 
          setOpenSuccessEditModal(false)
          setTimeout(() => {
            const params = {
              ...pagination,
              ...filters,
              page: 0,
              ...order
            }
            handleAttributes(params)

          }, [100])
        }
        }
        text={successModalEditText}
        title={translate('missionMenu.successModal.title.6')}
        okButton={"OK"}
      />
    )
  }
  const renderSuccessDeleteModal = () => {
    if (!openEditSuccessDeleteModal) return
    return (
      <PictogramModalNew
        onConfirm={() => { 
          setopenEditSuccessDeleteModal(false)
          setTimeout(() => {
            const params = {
              ...pagination,
              ...filters,
              page: 0,
              ...order
            }
            handleAttributes(params)

          }, [100])
        }
        }
        text={successModalDeleteText}
        title={translate('missionMenu.successModal.title.6')}
        okButton={"OK"}
      />
    )

  }
  const renderSuccessModal = () => {
    if (!openSuccessModal) return

    return (
      <PictogramModalNew
        onConfirm={() => { 
          setOpenSuccessModal(false)
          setTimeout(() => {
            const params = {
              ...pagination,
              ...filters,
              page: 0,
              ...order
            }
            handleAttributes(params)

          }, [100])
        }
        }
        text={successModalText}
        title={translate('missionMenu.successModal.title.6')}
        okButton={"OK"}
      />
    )
  }

  const handleUpdate = async (formData, id) => {
    
    updateAttribute(dsToken, formData, id)
  }
  const beforeSave = async (formData) => {
    
    saveAttribute(dsToken, formData )
  }
  const handleViewModal = (index) => {
    
    setOpenViewModel({show: true, selected: index})
  }

  useEffect(() => {
    if(cdMissionList.length > 0 && !actionMode) {
      setActionMode(true)
    }

  }, [cdMissionList])

  const handleOrder = (order,orderDirection) => {
    const param = {
      ...filters,
      ...pagination,
      order,
      orderDirection
    }

    setOrder({order, orderDirection})

    handleAttributes(param)
  }

  const inActionMode = cdMissionList.length > 0

  return (
    <div className='stock-adjustment'>
      <div ref={headerRef} className='stock-adjustment-header'>
        <ContentHeader>{translate('Banco de pictogramas')}</ContentHeader>
      </div>
      <div ref={filterRef} className='padding-bottom header-mission-block'>
          <div style={{display: inActionMode ? 'none' : ''}}>
            <FilterForm  visible={!actionMode} submit={setValues} translate={translate} />
          </div>
          <Title
            attributesSelected={cdMissionList}
            cdMissionListLength={cdMissionList.length}
            handleSideFilterMenuCollapseChange={setSideFilterVisible}
            setCdMissionList={setCdMissionList}
            setRemoveModal={(attr) => setOpenDeleteModal({show: true, selected: attr})}
            sideFilterVisible={sideFilterVisible}
            translate={translate}
          />

           <div>
              <button 
              style={{display: inActionMode ? 'none' : '', marginRight: '24px', background: "#41A017", borderRadius: '8px', height:'44px', color: "#fff"}} 
                className='btn filter-mission-block' onClick={() => setOpenAddModal(true)}>
                Cadastrar atributo
              </button>

              <button style={{display: inActionMode ? 'none' : '', marginRight: '27px'}} className='btn filter-mission-block' onClick={() => setSideFilterVisible(true)}>
                <FilterSVG newDesign={false} className="common-download"/>
                <span>{translate('commonReport.filters')}</span>
              </button>
           </div>

      </div>
      <div
        style={{ margin: '0 !important' }}
        ref={tableRef}
        className='stock-adjustment-table new'
      >

          <div style={{boxShadow: (get.record.resultList ?? []).length < 1 && 'none'}} className='outer-table stock-transfer-outer-table'>
            <div className='flex'>
              <SideFilterForm
                user={auth.user}
                resetFilters={resetFilters}
                closeFilters={closeFilter}
                depositList={depositListWithoutPermission}
                handleSideFilterElementChange={setSideFilterElement}
                initialValues={DEFAULT_INITIAL_VALUES}
                sideFilterVisible={sideFilterVisible}
                submit={setValues}
                translate={translate}
              />
              {(get.record.resultList ?? []).length ? (
                <Table
                  emptyFilter={emptyFilter}
                  removeSelected={removeSelected}
                  cdMissionList={cdMissionList}
                  handleOrder={handleOrder}
                  handleResize={handleResize}
                  closeModal={(attr) => setOpenDeleteModal({show:true, selected:attr})}
                  openModal={(index) => handleViewModal(index)}
                  editModal = {(attr) => setOpenEditModal({show: true, selected: attr})}
                  records={get.record.resultList}
                  setCdMissionList={setCdMissionList}
                  translate={translate}
                />
              ) : emptyFilter
              ? 
              <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
                
                <p>Não há cadastros no filtro selecionado</p>
              </div> 
              :   (
                <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
                
                <p>Sem resultado de busca</p>
                <p>Por favor, tente realizar uma nova busca com outro atributo/característica.</p>
                </div>
              )}
            </div>
           {renderNewPagination()}
          </div>

      </div>
      {renderEditModal()}
      {renderAddModal()}
      {renderViewModel()}
      {renderRemoveModal()}
      {renderErrorModal()}
      {renderSuccessModal()}
      {renderSuccessEditModal()}
      {renderSuccessDeleteModal()}

    </div>
  )
}

PictogramContainer.propTypes = {
  auth: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  logout: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  missionBlockError: PropTypes.object,
  pages: PropTypes.number.isRequired,
  saveAttribute: PropTypes.func.isRequired,
  fetchAttributes: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  attributeReducer:PropTypes.object,
  save:PropTypes.object,
  update:PropTypes.object,
  deleteAttributes:PropTypes.func,
  resetSave: PropTypes.func,
  resetAll: PropTypes.func,
  updateAttribute: PropTypes.func,
  get: PropTypes.object
}

/* istanbul ignore next */
const mapStateToProps = ({
  attributeReducer,
  paginateReducer,
}) => ({
  
  ...attributeReducer,
  ...paginateReducer,
  pages: paginateReducer.pages,
  get: attributeReducer.get,
  save: attributeReducer.save,
  update: attributeReducer.update
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...attributeActions,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    PictogramContainer
  )
)

export { PictogramContainer }
